import { render, staticRenderFns } from "./RecoMobile.vue?vue&type=template&id=360f7cf5&scoped=true"
import script from "./RecoMobile.vue?vue&type=script&lang=js"
export * from "./RecoMobile.vue?vue&type=script&lang=js"
import style0 from "./RecoMobile.vue?vue&type=style&index=0&id=360f7cf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360f7cf5",
  null
  
)

export default component.exports